/**
 * Global Main - Optional Components
 * Import optional components that should be available site-wide
 * This file can be customized based on what components you want to include
 */

// Import VideoSection lazy loader (optional component)
import '../components/videoSectionLoader.js';

// Import SliderComponent for section-container sliders
import '../components/SliderComponent.js';

// Import StickyATC component for product pages
import '../components/StickyATC.js';

import '../components/DropDownElement.js';
import '../components/HeaderMegaMenu.js';
import '../components/Modal.js';

// Add other optional global components here as needed
// Example:
// import './modalLoader.js';
// import './notificationSystem.js';
// Allow adding Accordion on other pages
import '../components/AccordionElement.js'
// TEMPORARY DEBUG: Video section troubleshooting
console.log('🔍 [Debug] Starting video section debug...');

// Check if VideoSection is available
console.log('🔍 [Debug] VideoSection available:', !!window.VideoSection);
console.log('🔍 [Debug] VideoSectionLazyLoader available:', !!window.VideoSectionLazyLoader);

// Debug function to check video sections
function debugVideoSections() {
  // Find all video sections (support both video-section and video-with-content)
  const videoSections = document.querySelectorAll('[data-section-type="video"], [data-section-type="video-with-content"]');
  console.log('🔍 [Debug] Video sections found:', videoSections.length);

  videoSections.forEach((section, index) => {
    console.log(`🔍 [Debug] Video section ${index + 1}:`, {
      sectionId: section.dataset.sectionId,
      hasVideoLazyInit: section.hasAttribute('data-video-lazy-init'),
      hasVideoElement: !!section.querySelector('.video-section__video'),
      hasYouTubeThumb: !!section.querySelector('.video-section__youtube-thumb'),
      hasVimeoThumb: !!section.querySelector('.video-section__vimeo-thumb'),
      hasPlayButton: !!section.querySelector('.video-section__play-button'),
      hasPoster: !!section.querySelector('.video-section__poster')
    });
    
    // Check video element details
    const videoElement = section.querySelector('.video-section__video');
    if (videoElement) {
      console.log(`🔍 [Debug] Video element ${index + 1}:`, {
        src: videoElement.src,
        dataVideoSrc: videoElement.dataset.videoSrc,
        dataVideoSrcMobile: videoElement.dataset.videoSrcMobile,
        dataAutoplayOnView: videoElement.dataset.autoplayOnView,
        muted: videoElement.muted,
        controls: videoElement.controls,
        loop: videoElement.loop,
        preload: videoElement.preload,
        hasObserver: videoElement.hasAttribute('data-video-observer-attached'),
        paused: videoElement.paused,
        readyState: videoElement.readyState,
        currentTime: videoElement.currentTime,
        duration: videoElement.duration
      });
    }
    
    // Check YouTube details
    const youtubeThumb = section.querySelector('.video-section__youtube-thumb');
    if (youtubeThumb) {
      console.log(`🔍 [Debug] YouTube thumb ${index + 1}:`, {
        youtubeId: youtubeThumb.dataset.youtubeId,
        hasImage: !!youtubeThumb.querySelector('img'),
        imageSrc: youtubeThumb.querySelector('img')?.src
      });
    }
    
    // Check Vimeo details
    const vimeoThumb = section.querySelector('.video-section__vimeo-thumb');
    if (vimeoThumb) {
      console.log(`🔍 [Debug] Vimeo thumb ${index + 1}:`, {
        vimeoId: vimeoThumb.dataset.vimeoId,
        hasImage: !!vimeoThumb.querySelector('img'),
        imageSrc: vimeoThumb.querySelector('img')?.src
      });
    }
  });
}

// Enhanced video debugging function
function debugVideoPlayback() {
  console.log('🎥 [Video Debug] Checking video playback status...');
  
  const allVideos = document.querySelectorAll('video');
  console.log(`🎥 [Video Debug] Found ${allVideos.length} video elements`);
  
  allVideos.forEach((video, index) => {
    const rect = video.getBoundingClientRect();
    const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
    const visibilityPercentage = Math.max(0, Math.min(100, 
      ((Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)) / rect.height) * 100
    ));
    
    console.log(`🎥 [Video Debug] Video ${index + 1}:`, {
      src: video.src,
      paused: video.paused,
      readyState: video.readyState,
      currentTime: video.currentTime,
      duration: video.duration,
      isInViewport: isInViewport,
      visibilityPercentage: `${visibilityPercentage.toFixed(1)}%`,
      hasObserver: video.hasAttribute('data-video-observer-attached'),
      autoplay: video.autoplay,
      muted: video.muted,
      controls: video.controls,
      loop: video.loop
    });
  });
}

// Make debug functions available globally
window.debugVideoSections = debugVideoSections;
window.debugVideoPlayback = debugVideoPlayback;

// Run debug when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', debugVideoSections);
} else {
  debugVideoSections();
}

// Also run debug after a delay to catch any dynamically loaded sections
setTimeout(debugVideoSections, 2000);

console.log('🌍 [Global] Optional components loaded');
